import Phaser from 'phaser';
import { DEPTH } from '../game/depth';
import { UI_FONT } from '../ui/theme';
import type { RemotePose } from '../net/protocol';

const ANIM: Record<string, string> = {
  idle: 'anim-stand',
  walk: 'anim-walk',
  air: 'anim-jump',
  attack: 'anim-attack',
  swing: 'anim-attack',
  hurt: 'anim-hurt',
  dead: 'anim-dead',
  climb: 'anim-climb',
};

export class RemotePlayer {
  readonly sprite: Phaser.GameObjects.Sprite;
  readonly label: Phaser.GameObjects.Text;
  id: string;
  name: string;
  mapId: string;
  private tx: number;
  private ty: number;

  constructor(scene: Phaser.Scene, pose: RemotePose) {
    this.id = pose.id;
    this.name = pose.name;
    this.mapId = pose.mapId;
    this.tx = pose.x;
    this.ty = pose.y;
    this.sprite = scene.add.sprite(pose.x, pose.y, 'player-stand', 0);
    this.sprite.setOrigin(0.5, 1).setDepth(DEPTH.remotePlayer).setAlpha(0.92);
    this.label = scene.add
      .text(pose.x, pose.y - 78, pose.name, {
        fontFamily: UI_FONT,
        fontSize: '11px',
        color: '#c8e0ff',
        stroke: '#14141c',
        strokeThickness: 3,
        wordWrap: { width: 140, useAdvancedWrap: true },
        align: 'center',
      })
      .setOrigin(0.5, 1)
      .setDepth(DEPTH.remotePlayer);
    this.applyAnim(pose);
  }

  sync(pose: RemotePose): void {
    this.name = pose.name;
    this.mapId = pose.mapId;
    this.tx = pose.x;
    this.ty = pose.y;
    this.label.setText(pose.name);
    this.applyAnim(pose);
  }

  update(): void {
    this.sprite.x += (this.tx - this.sprite.x) * 0.28;
    this.sprite.y += (this.ty - this.sprite.y) * 0.28;
    this.label.setPosition(this.sprite.x, this.sprite.y - 78);
  }

  destroy(): void {
    this.sprite.destroy();
    this.label.destroy();
  }

  private applyAnim(pose: RemotePose): void {
    this.sprite.setFlipX(pose.facing < 0);
    const key = ANIM[pose.mode] ?? 'anim-stand';
    if (this.sprite.anims.currentAnim?.key !== key) this.sprite.play(key, true);
  }
}
